module.exports = __webpack_public_path__ + "static/logo-dark-9beb974c6aec35037890d189beec6e6e.svg";